// frontend_react/src/services/restaurantApi.js

import React from "react";
import api, { buildCompanyScopeHeaders } from "./api";

export const fetchRooms = ({ companyUuid } = {}) =>
  api.get("/restaurant/rooms", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const fetchCategories = ({ companyUuid } = {}) =>
  api.get("/restaurant/categories", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const fetchOrders = ({ companyUuid } = {}) =>
  api.get("/restaurant/orders", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createOrder = (payload, { companyUuid } = {}) =>
  api.post("/restaurant/orders", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const closeOrder = (orderUuid, { companyUuid } = {}) =>
  api.post(
    `/restaurant/orders/${orderUuid}/close`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const mergeOrders = (payload, { companyUuid } = {}) =>
  api.post("/restaurant/orders/merge", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const checkoutOrder = (orderUuid, { companyUuid } = {}) =>
  api.post(
    `/restaurant/orders/${orderUuid}/checkout`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const prepareOrderItems = (orderUuid, { companyUuid } = {}) =>
  api.post(
    `/restaurant/orders/${orderUuid}/prepare`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const addOrderItem = (orderUuid, payload, { companyUuid } = {}) =>
  api.post(`/restaurant/orders/${orderUuid}/items`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const updateOrderItem = (orderUuid, itemUuid, payload, { companyUuid } = {}) =>
  api.put(`/restaurant/orders/${orderUuid}/items/${itemUuid}`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteOrderItem = (orderUuid, itemUuid, { companyUuid } = {}) =>
  api.delete(`/restaurant/orders/${orderUuid}/items/${itemUuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });
